import apiClient from '../../shared/auth/services'

export const kyotenKanriService = {
  // Get branch list including deleted branches
  async getKyotenList() {
    const response = await apiClient.post('/getKyotenList', {
      isContainDeleted: true
    })
    return response.data
  },

  // Add new branches
  async addKyotenList(newKyotenList) {
    const data = {
      kyotenList: newKyotenList.map(kyoten => ({
        kyotenId: kyoten.kyotenId,
        kyotenName: kyoten.kyotenName,
        kyotenSetsumei: kyoten.kyotenSetsumei,
        orderIndex: kyoten.orderIndex
      }))
    }
    const response = await apiClient.post('/addKyotenList', data)
    return response.data
  },

  // Update existing branches
  async updateKyotenList(updatedKyotenList) {
    const data = {
      kyotenList: updatedKyotenList.map(kyoten => ({
        kyotenId: kyoten.kyotenId,
        kyotenName: kyoten.kyotenName,
        kyotenSetsumei: kyoten.kyotenSetsumei,
        deleteFlg: kyoten.deleteFlg,
        orderIndex: kyoten.orderIndex
      }))
    }
    const response = await apiClient.post('/updateKyotenList', data)
    return response.data
  },

  // Remove branches (mark as deleted)
  async removeKyotenList(removedKyotenList) {
    const data = {
      kyotenList: removedKyotenList.map(kyoten => ({
        kyotenId: kyoten.kyotenId
      }))
    }
    const response = await apiClient.post('/removeKyotenList', data)
    return response.data
  }
}

export default kyotenKanriService
